/* global d3, $ */

export function selectRect(x, svg) {
  var person = d3.select('g[data-slug="' + x + '"]');

  svg.selectAll('g').classed('graph__person--active', false);
  svg.selectAll('g[data-slug="' + x + '"]').classed('graph__person--active', true);

  $('.name__highlight').removeClass('name__active');
  $('#sections').find('span[data-name="' + x + '"]').addClass('name__active');

  return person;
}

export function getModalNavOptions(x, grid) {
  var nextG,
      nextSlug,
      prevG,
      prevSlug,
      selected = x,
      navOptions = [];

  var groups = grid.groups();

  $(groups).each(function(i) {
    for(var j=0; j < this.data.length; j++) {
      // if it matches
      if (selected === this.data[j].name_slug) {
        // see if next slug in group exists
        if (this.data[j + 1] === undefined) {
          // if not, check if there's a next group
          if (groups[i + 1] === undefined) {
            // if not, go to beginning
            nextG = groups[0].data[0];
          } else {
            // otherwise, start at next group
            nextG = groups[i + 1].data[0];
          }
        } else {
          // advance to next slug in active group
          nextG = this.data[j + 1];
        }

        if (this.data[j - 1] === undefined) {
          // if its the first group
          if (i === 0) {
            var lastGroup = groups[groups.length - 1];
            prevG = lastGroup.data[lastGroup.data.length - 1];
          } else {
            var prevGroup = groups[i-1];
            prevG = prevGroup.data[prevGroup.data.length - 1];
          }
        } else {
          prevG = this.data[j - 1];
        }

        nextSlug = nextG.name_slug;
        prevSlug = prevG.name_slug;

        navOptions = [prevSlug, nextSlug];
      }
    }
  });

  $('#graph__modal--prev').attr('data-name', navOptions[0]);
  $('#graph__modal--next').attr('data-name', navOptions[1]);
}

export function graphModalPopup(x, d, svg, grid, graphModal) {
  // Remove all other active classes on rect
  getModalNavOptions(x, grid);

  selectRect(x, svg);
  // Reveal Modal
  // ADD check to see if its already open
  if (!graphModal.hasClass('open')) {
    graphModal.addClass('open');
    graphModal.animate({left: 0}, 500);
  }

  graphModal.width($('#sections').width());

  // Set Modal Content
  $('#graph__modal--name').html(d.first_name + ' ' + d.last_name);
  $('#graph__modal--nar').html(d.nar);

  if(d.photo_status === 'yes') {
    $('#graph__modal--image').attr('src', 'assets/images/mugs/' + d.photo);
  } else if (d.photo_status === 'withheld'){
    $('#graph__modal--image').attr('src', 'assets/images/withheld.png');
  } else {
    $('#graph__modal--image').attr('src', 'assets/images/unavailable.png');
  }

  if(d.dutystation_state) {
    $('#graph__modal--dutystation').html(d.dutystation_city + ', ' + d.dutystation_state);
  } else {
    $('#graph__modal--dutystation').html(d.dutystation_city);
  }

  if(!d.yearsservice) {
    $('#graph__modal--yearsofservice').html('Unknown');
  } else {
    $('#graph__modal--yearsofservice').html(d.yearsservice + ' years');
  }

  if(d.prisontime === '0' && d.prisontimemonths === '0') {
    $('#graph__modal--prisonsentence').html('None');
  } else if (d.prisontime === '0' && d.prisontimemonths === '1') {
    $('#graph__modal--prisonsentence').html(d.prisontimemonths + ' month');
  } else if (d.prisontime === '1' && d.prisontimemonths === '0') {
      $('#graph__modal--prisonsentence').html(d.prisontime + ' year');
  } else if (d.prisontime === '0' && d.prisontimemonths !== '0') {
    $('#graph__modal--prisonsentence').html(d.prisontimemonths + ' months');
  } else if (d.prisontime !== '0' && d.prisontimemonths === '0') {
    $('#graph__modal--prisonsentence').html(d.prisontime + ' years');
  } else if (d.prisontime === '1' && d.prisontimemonths === '1') {
    $('#graph__modal--prisonsentence').html(d.prisontime + ' year, ' + d.prisontimemonths + ' month');
  } else if (d.prisontime === '1' && d.prisontimemonths !== '0') {
    $('#graph__modal--prisonsentence').html(d.prisontime + ' year, ' + d.prisontimemonths + ' months');
  } else if (d.prisontime !== '0' && d.prisontimemonths === '1') {
    $('#graph__modal--prisonsentence').html(d.prisontime + ' years, ' + d.prisontimemonths + ' month');
  } else if (d.prisontime === 'N/A' || d.prisontime === 'Sentence Pending') {
    $('#graph__modal--prisonsentence').html(d.prisontime);
  } else {
    $('#graph__modal--prisonsentence').html(d.prisontime + ' years, ' + d.prisontimemonths + ' months');
  }
}

export function graphModalClose(svg, graphModal) {
  graphModal.removeClass('open');
  graphModal.animate({left: '-100%'}, 500);
  graphModal.width(0);
  svg.selectAll('rect').classed('graph__modal--active', false);
  $('.name__highlight').removeClass('name__active');
}



/** WEBPACK FOOTER **
 ** ./includes/gridModal.js
 **/